import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { SOCIAL_PLATFORMS, getSocialIconMarkup, normalizeSocialLinks } from "../socialLinks";

export default function SocialLinksModal({ isOpen, onClose, onSave, initialLinks = {}, title = "Social Media Links", submitLabel = "Insert Social Icons Block" }) {
  const [links, setLinks] = useState(initialLinks);
  useEffect(() => {
    if (isOpen) setLinks(initialLinks || {});
  }, [initialLinks, isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave(normalizeSocialLinks(links));
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-5 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold text-bookish-purple">{title}</h3>
          <button type="button" onClick={onClose} className="p-1 hover:bg-bookish-purple/10 rounded-lg transition-colors">
            <X size={18} />
          </button>
        </div>

        <div className="space-y-2.5 max-h-[calc(100vh-120px)] sm:max-h-80 overflow-y-auto">
          {SOCIAL_PLATFORMS.map((platform) => (
            <div key={platform.key} className="flex items-center gap-2.5">
              <span
                className="w-8 h-8 rounded-full flex items-center justify-center text-white flex-shrink-0"
                style={{ background: platform.color }}
                dangerouslySetInnerHTML={{ __html: getSocialIconMarkup(platform) }}
              />
              <div className="flex-1">
                <label className="text-[10px] text-bookish-purple/50 block">{platform.label}</label>
                <input
                  type="url"
                  placeholder={`https://${platform.key}.com/yourprofile`}
                  value={links[platform.key] || ""}
                  onChange={(e) => setLinks((prev) => ({ ...prev, [platform.key]: e.target.value }))}
                  className="w-full border border-bookish-purple/15 rounded-lg px-2.5 py-1.5 text-sm bg-white focus:ring-1 focus:ring-bookish-purple/30"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="flex gap-2 pt-2 border-t border-bookish-purple/8">
          <button
            onClick={onClose}
            className="flex-1 px-3 py-2 text-sm font-medium rounded-lg border border-bookish-purple/15 hover:bg-bookish-purple/5"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex-1 px-3 py-2 text-sm font-medium rounded-lg bg-bookish-purple text-white hover:bg-bookish-purpleAccent transition-colors"
          >
            {submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
